import React, { useCallback, useMemo, useRef, useState } from "react";
import { REP_IMG } from "../../../../../shared/Data/typeDirs";
import { Col, Dropdown, Form, Overlay, Popover, Row, Spinner } from "react-bootstrap";
import { /*Button,*/ FormLabel, Input } from '@mui/joy'
import {Button} from 'react-bootstrap'
import np from "../../../../../shared/Images/no_photo.jpg"
import { useControl, useControlReducer } from "../../../controlContext";
import { useAppContainerContext } from "../../../../revised_components/appContainer/context";
import { usePhotoManagerContext } from "../../../../revised_components/contextProviders/photoManagerContext";
import { ReportImage } from "../../../../../shared/Objects/newReportObjects/reportImage";
import { dataSource } from "../../../../../services/dataSource";
import { downloadDropboxFileToLocation, uploadDropboxFileOverwrite } from "../../../../../services/dropboxRequests";
import { useSource, useSourceReducer } from "../../../sourceContext";
import { useUserContext } from "../../../../revised_components/contextProviders/userContext";
// import { ProgressElement } from "../../../../revised_components/progressElement";
import { useNotificationContext } from "../../../../revised_components/contextProviders/notificationContext";
import { filesGetThumbnailBatch } from "../../../../../services/dropboxRequests";
import '../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/report_images.css'
import { ArrowLeft, ArrowRight, File, Menu, RefreshCcw, Trash2 } from "react-feather";
import { getThumbnails, requestFileFromUser } from "../../../../../services/networkRequests";
import { IMG_SIZES } from "../../../../../shared/Data/consts";
import { useControlHeaderContext } from "../../../controlWrapperContext";
// import typeMap from "../../../../../shared/Data/typeMap";
import { genId } from "../../../../../shared/utils";
let dialog = null;
if (window && window.require) {
  try {
    dialog = window.require('@electron/remote').dialog;
  } catch (e) {
    dialog = null;
  }
}

// const [_no, MD, LG, _alsoNo] = IMG_SIZES
const MD = IMG_SIZES[1]
const LG = IMG_SIZES[2]
const IMG_OPTIONS = [MD, LG]

export function ReportImagesControl({ idx, name, objectMetadata, label }) {
  const { [idx]: block } = useControl()
  const { [REP_IMG]: reportImages } = block
  const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
  const readOnly = useMemo(() => (allReadOnly || (lockMap && lockMap[block._id])), [allReadOnly, lockMap, block._id])
  const { imageMap } = useSource()
  const controlReducer = useControlReducer()
  const { user } = useUserContext()
  const sourceReducer = useSourceReducer()
  const { isDragging, setProgress, setIsDragging } = useAppContainerContext()
  const [isDraggingOverPanel, setIsDraggingOverPanel] = useState(false)
  const [mouseOverImage, setMouseOverImage] = useState({ target: false, idx: false })
  // const mouseOverRef = useRef()
  const { photoUploadManager } = usePhotoManagerContext()
  const displayNotif = useNotificationContext()
  const [deleteAttempted, setDeleteAttempted] = useState(false)
  const [loading, setLoading] = useState(false)
  let timeout_id = useRef()

  // console.log("REPORT IMAGES DIRNAME", objectMetadata)


  // function progressCallback(status) {
  //   if (!status.isRunning) {
  //     setProgress(false)
  //     return
  //   }
  //   setProgress(
  //     ProgressElement(status.num, status.den, `Moving images from DBGallery: (${status.num} / ${status.den})`)
  //   )
  // }

  async function dropImage(evt, orderIdx) {
    evt.stopPropagation()
    evt.preventDefault()
    setLoading(true)
    setIsDraggingOverPanel(false)
    setIsDragging(false)

    if (reportImages.length >= 40) {
      displayNotif('danger', 'Maximum of 40 images per block')
      return
    }

    let data = evt.dataTransfer.getData('text')
    let maybeArray = data.split(',')

    displayNotif('info', `Adding image${maybeArray.length == 1 ? '' : 's'}...`);
 

    if (Array.isArray(maybeArray) && maybeArray.every(itm => (itm.length && itm.length <= 8))) {
      await dropDBGImage(maybeArray, orderIdx)
    } else {
      let paths = evt.dataTransfer.files
      console.log('report-image-drop-panel', orderIdx % 2 === 1 ? 'LEFT' : 'RIGHT', ' | made paths:', paths)
      await dropLocalImage(paths, orderIdx)
    }
    setLoading(false)
    // setIsDraggingOverPanel(false)
  }

  async function dropLocalImage(paths, orderIndex) {
    let newImages = []
    for (let i_p = 0; i_p < paths.length; i_p++) {
      let newImageId = genId()
      newImages.push(new ReportImage({
        _id: newImageId,
        _reports_v2: objectMetadata._id,
        _report_blocks: block._id,
        orderIndex: orderIndex + i_p,
        dropboxPath: ReportImage.getDropboxArchivePath(newImageId, objectMetadata.dirName),
        storageLocation: 'dropbox'
      }))
      photoUploadManager.addToQueue([{
        file: paths[i_p],
        dropbox_path: newImages[i_p].dropboxPath
      }])
    }


    newImages = newImages.map((itm, idx)=>({...itm, orderIndex: `${orderIndex+idx}`}))
    displayNotif('info', `Adding image${newImages.length == 1 ? '' : 's'}...`);

    controlReducer({
      idx, name, type: 'changed', update: {[name]: [
        ...reportImages.slice(0, orderIndex),
        ...newImages,
        ...reportImages.slice(orderIndex, reportImages.length).map((itm, idx)=>({...itm, orderIndex:`${idx + newImages.length + orderIndex}`}))
      ]}, childAction: { type: 'add_blocks', name: 'dropZone', blocks: newImages }
    })
    await photoUploadManager.executeQueue((prog) => setProgress(prog), user.token)
    let thumbnailQueueItems = newImages.map(img => ({ path: img.dropboxPath, storageLocation: 'dropbox' }))
    let thumbRes = await filesGetThumbnailBatch(thumbnailQueueItems, false, user.token)
    let newMapImageData = {}
    for (let res of thumbRes) {
      if (res.thumbnail) newMapImageData[res.metadata.name.split('.')[0]] = res.thumbnail

    }
    console.log('updating imagemap', newMapImageData)
    sourceReducer({
      type: 'update_imageMap',
      imageData: newMapImageData,
      name: REP_IMG,
      photo_update: thumbnailQueueItems

    })
    // photoUploadManager.addToQueue(paths)

  }

  async function dropDBGImage(dbgIdArray, orderIndex) {
    let newImages = []
    dbgIdArray.forEach((dbg_id, idx) => {
      newImages.push(new ReportImage({
        dbg_id,
        _reports_v2: objectMetadata._id,
        _report_blocks: block._id,
        orderIndex: orderIndex + idx,
        storageLocation: 'dbgallery'
      }))
      return { dbg_id, _id: newImages[idx]._id, typeDir: REP_IMG }
    })
    for (let img of newImages) await dataSource('remDb')[REP_IMG].put(img)
    let thumbnailQueueItems = newImages.map(({ dbg_id, _id, thumbnailSize, storageLocation }) => ({ dbg_id, _id, thumbnailSize, storageLocation }))
    let thumbnailData = await getThumbnails(thumbnailQueueItems, user.token)
    let newMapImageData = {}
    for (let res of thumbnailData) {
      if (res.thumbnail) newMapImageData[res.metadata.name.split('.')[0]] = res.thumbnail
    }
    console.log('updating imagemap', newMapImageData)
    sourceReducer({
      type: 'update_imageMap',
      imageData: newMapImageData,
      name: REP_IMG,
      photo_update: thumbnailQueueItems

    })
    newImages=  newImages.map((itm, idx)=>({...itm, orderIndex: `${orderIndex+idx}`}))
    controlReducer({
      idx, name, type: 'changed', update: {[name]: [
        ...reportImages.slice(0, orderIndex),
        ...newImages,
        ...reportImages.slice(orderIndex, reportImages.length).map((itm, idx)=>({...itm, orderIndex:`${idx + newImages.length + orderIndex}`}))
      ]}, childAction: { type: 'add_blocks', name: 'dropZone', blocks: newImages }
    })
  }

  const captionChange = useCallback((orderIndex, value) => {
    clearTimeout(timeout_id.current)
    timeout_id.current = setTimeout(() => controlReducer({
      idx, name, type: 'changed', update: {[name]: [
        ...reportImages.slice(0, orderIndex),
        { ...reportImages[orderIndex], content: value },
        ...reportImages.slice(orderIndex + 1, reportImages.length)
      ]}, childAction: { idx: orderIndex, type: 'changed', name: 'content', update: {content:value} }
    }), 200)

  }, [reportImages, controlReducer, idx, name])


  async function useDialogToUploadPhotos() {
    // if (dialog) {
      // Electron: use dialog
      // let res = await dialog.showOpenDialog(
      //   { title: 'Upload local photos', properties: ['openFile', 'multiSelections'], buttonLabel: 'Upload', filters: [{ name: 'Images', extensions: ['jpg', 'jpeg'] }] }
      // )
      let res = await requestFileFromUser('.jpg,.jpeg', true)
      console.debug('got res from file select', res)
      dropLocalImage(res, 0)
    // } else {
      // Web: use a hidden file input
      // const input = document.createElement('input');
      // input.type = 'file';
      // input.accept = '.jpg,.jpeg';
      // input.multiple = true;
      // input.style.display = 'none';
      // input.onchange = (event) => {
      //   const files = Array.from(event.target.files);
      //   // Convert File objects to a format your dropLocalImage can handle
      //   // If dropLocalImage expects { path }, you may need to adjust this
      //   dropLocalImage(files.map(file => ({ file })), 0);
      // };
      // document.body.appendChild(input);
      // input.click();
      // // Clean up
      // input.remove();
    // }
  }

  const mappedComponent = useMemo(() => {

    function closeOverlay() {
      // console.log('closing overlay', timeout_id.current)
      clearTimeout(timeout_id.current)
      timeout_id.current = setTimeout(() => {
        setMouseOverImage({ ...mouseOverImage, idx: false })
        setDeleteAttempted(false)
      }, 500)
    }
    let rows = []
    let images = []
    let addedLength = 0
    const showOverlay = !!(mouseOverImage.idx === 0 || mouseOverImage.idx)
    const overlay = (
      <PhotoOverlay
        idx={idx}
        name={name}
        show={showOverlay}
        objectMetadata={objectMetadata}
        reportImages={reportImages}
        closeOverlay={closeOverlay}
        mouseOverImage={mouseOverImage}
        setMouseOverImage={setMouseOverImage}
        deleteAttempted={deleteAttempted}
        setDeleteAttempted={setDeleteAttempted}
        keepOpen={() => clearTimeout(timeout_id.current)}
      />
    )

    for (let i = 0; i < reportImages.length + addedLength; i++) {
      let imageComponent = (
        <Col
          className="report-image-col"
          key={`${reportImages[i]._id}:${i}`}
          sm={reportImages[i].thumbnailSize === 'lg' ? 12 : 6}
        >
          <div className={"report-image-container " + (reportImages[i].thumbnailSize ? reportImages[i].thumbnailSize : '')} >
            {readOnly ? [] : (
              <div className={`report-image-drop-mask`}
                onMouseLeave={closeOverlay}
                onMouseOver={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  // console.log('setting mouseover', e.currentTarget)
                  clearTimeout(timeout_id.current)
                  setMouseOverImage({ ...mouseOverImage, idx: i })
                  setDeleteAttempted(false)
                }} >
                {loading?(<Spinner className="report-image-load-spinner" animation="border"/>):['left', 'right'].map(side => (
                  <div key={side}
                    className={`report-image-drop-panel ${side} ${isDraggingOverPanel && (isDraggingOverPanel[1] === side) && (isDraggingOverPanel[0] === i) ? 'over' : ''}`}
                    onDragOver={evt => {
                      evt.stopPropagation()
                      evt.preventDefault()
                      // console.log('dragging over')
                      setIsDraggingOverPanel([i, side])
                    }}
                    onDragLeave={(evt) => {
                      evt.stopPropagation()
                      evt.preventDefault()
                      setIsDraggingOverPanel(false)
                    }}
                    onDrop={(evt) => dropImage(evt, side === 'right' ? i + 1 : i)}
                  >
                    {side === 'right' && mouseOverImage.idx === i ? (
                      <Button variant="activated" className="report-image-hover-button" onMouseOver={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        // console.log('setting mouseover', e.currentTarget)
                        clearTimeout(timeout_id.current)
                        setMouseOverImage({ target: e.currentTarget, idx: i })
                        setDeleteAttempted(false)
                      }}
                        onMouseLeave={closeOverlay}><Menu /></Button>
                    ) : []}
                  </div>
                ))}
              </div>
            )}
            <img
              className={"report-image " + (reportImages[i].thumbnailSize ? reportImages[i].thumbnailSize : '')}
              alt={`${REP_IMG}: #${i}`}
              src={imageMap && imageMap[reportImages[i]._id] ? `data:image/jpg;base64, ${imageMap[reportImages[i]._id]}` : np}
            />

            {readOnly ? (
              <div className="report-image-readonly-caption">
                {reportImages[i].content}
              </div>
            ) : (
              <Input
                variant="outlined"
                placeholder="Note"
                defaultValue={reportImages[i].content}
                className="report-image-input"
                onChange={evt => captionChange(i - addedLength, evt.target.value)} />
            )}
          </div>

        </Col>
      )
      if (reportImages[i].thumbnailSize === 'lg') {
        if (images.length) {
          rows.push(<Row key={rows.length}>{images}</Row>)
          images = []
        }
        rows.push(<Row key={rows.length}>{imageComponent}</Row>)
      } else {
        images.push(imageComponent)
        if (images.length === 2 || (images.length && i === reportImages.length - 1)) {
          rows.push(<Row key={rows.length}>{images}</Row>)
          images = []
        }
      }
    }


    if (!readOnly) {
      rows.push(
        <div className={`report-pre-image-box ${isDragging ? 'dragging' : ''} ${isDraggingOverPanel ? ' over' : ''}`}>      
            <div className={'report-pre-image-drop-mask'} 
              onDragOver={evt => {
                evt.stopPropagation()
                evt.preventDefault()
                // console.log('dragging over')
                setIsDraggingOverPanel([0])
              }}
              onDragLeave={(evt) => {
                evt.stopPropagation()
                evt.preventDefault()
                setIsDraggingOverPanel(false)
              }}
              onDrop={(evt) => dropImage(evt, 0)}
            ></div>

          <div className="g-0 report-images-empty">     
            <div className="report-pre-image-text">
              {`Drag and drop photos here`}
            </div>
            <div>
              <Button
                variant="soft"
                color="primary"
                className="btn-custom-primary-soft"
                onClick={useDialogToUploadPhotos}
              >Upload photos</Button>
            </div>
          </div>
        </div>
      )
    }


    return [...rows, overlay]
  }, [reportImages, isDraggingOverPanel, imageMap, mouseOverImage, readOnly, deleteAttempted, captionChange, dropImage, idx, name, label, objectMetadata])

  const containerClassName = useMemo(() => isDragging && !readOnly ? 'report-image-control-container dragging' : 'report-image-control-container', [isDragging, readOnly])

  return (
    <div className="report-image-outer-container">
      {/* <div style={{ marginBottom: '5px' }} hidden={!label}>
        <FormLabel sx={{ m: 0 }}>{label}</FormLabel>
      </div> */}
      <div className={containerClassName}>
        {mappedComponent}
      </div>
      
    </div>
  )
}


function PhotoOverlay({
  show,
  mouseOverImage,
  reportImages,
  idx,
  name,
  setMouseOverImage,
  closeOverlay,
  objectMetadata,
  deleteAttempted,
  setDeleteAttempted,
  keepOpen
}) {
  const controlReducer = useControlReducer()
  const { user } = useUserContext()
  const sourceReducer = useSourceReducer()
  // const dirName = useMemo(()=>objectMetadata && objectMetadata.dirName, [objectMetadata])

  function moveImage(evt) {
    let imageIndex = parseInt(evt.currentTarget.name, 10)
    let move = parseInt(evt.currentTarget.value, 10)
    console.log('moving image', imageIndex, move, imageIndex+move)
    if (reportImages.length === 1) return
    if (imageIndex >= 5 && move === 1) return
    if (imageIndex === 0 && move === -1) return
    if (imageIndex + move >= reportImages.length) return

    const swapImmutable = (array, i, j) => {
      const newArray = [...array];
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
      return newArray;
    };
    
    let newReportImages = swapImmutable(reportImages, imageIndex, imageIndex + move).map((itm, idx)=>({...itm, orderIndex:`${idx}`}))

    console.log('moved image from', imageIndex, 'to', imageIndex+move, newReportImages)
    controlReducer({
      type: 'changed',
      name,
      idx,
      update:{[name]: newReportImages},
      childAction: { 
        type: 'changed', 
        idx: imageIndex, 
        name: 'orderIndex', 
        update: {
          _id: reportImages[imageIndex]._id, 
          _report_blocks:reportImages[imageIndex]._report_blocks, 
          orderIndex: `${imageIndex + move}` 
        }
      }
    })
    // setTimeout(()=>setMouseOverImage({...mouseOverImage, idx:imageIndex+move}),10)
    setMouseOverImage({ ...mouseOverImage, idx: false })
  }

  async function downloadPhoto(evt) {
    let imageIndex = evt.currentTarget.value
    let dbxPath = reportImages[imageIndex].dropboxPath
    // console.log('got file data', dbxFileData)
    // let locPath = ReportImage.getLocalPath(LOC_ROOT, objectMetadata.dirName, reportImages[imageIndex]._id)
    // locPath = sysPath(locPath)
    // let destFolder = locPath.slice(0, locPath.lastIndexOf('\\'))
    // console.log('checking dir,', destFolder)
    // destFolder = sysPath(destFolder)
    // let destExists = await checkIfExists(destFolder)
    // if (!destExists) await makeDir(destFolder, true)
    await downloadDropboxFileToLocation(dbxPath, false, user.token)
    // execModule('open-explorer', { File: locPath })

    // openImageInExplorer(locPath)
  }


  async function uploadImageAndRefresh(evt) {
    let imageIndex = evt.currentTarget.value
    let reportImage = reportImages[imageIndex]
    let dbxPath = reportImage.dropboxPath
    // let locPath = ReportImage.getLocalPath(LOC_ROOT, objectMetadata.dirName, reportImage._id)
    let data = await requestFileFromUser('.jpg,.jpeg')
    console.log('about to upload data', dbxPath, data)

    let res = await uploadDropboxFileOverwrite(data, dbxPath, user.token)
    console.log('completed upload', res)
    // let resMapper = function (result) {
    //   return result.entries
    // }
    // let newThumb = await filesGetThumbnailBatch([dbxPath], resMapper)
    // newThumb = newThumb[0]
    // console.log('got new thumb', newThumb)
    // const newImageMapData = {
    //   [_id]: newThumb.thumbnail
    // }
    updateImageMap([{ _id: reportImage._id }])
  }

  async function updateImageMap(queueItems) {
    let thumbRes = await getThumbnails(queueItems, user.token)
    let newMapImageData = {}
    for (let res of thumbRes) {
      if (res.thumbnail) newMapImageData[res.metadata.name.split('.')[0]] = res.thumbnail
    }
    console.log('updating imagemap', newMapImageData)
    sourceReducer({ type: 'update_imageMap', imageData: newMapImageData, name: REP_IMG, photo_update: queueItems })
  }

  function onSelectThumbnailSize(eventKey) {
    console.log('setting new thumb size for image', eventKey, mouseOverImage.idx)
    controlReducer({
      type: 'changed', idx, name, update: {[name]: [
        ...reportImages.slice(0, mouseOverImage.idx),
        { ...reportImages[mouseOverImage.idx], thumbnailSize: eventKey },
        ...reportImages.slice(mouseOverImage.idx + 1)
      ]},
      photo_update: [generateThumbnailRequest(reportImages[mouseOverImage.idx])],
      childAction: {type: 'changed', idx: mouseOverImage.idx, name: 'thumbnailSize', update: {thumbnailSize:eventKey} }
    })
    setTimeout(() => updateImageMap([{
      _id: reportImages[mouseOverImage.idx]._id,
      thumbnailSize: eventKey,
      storageLocation: reportImages[mouseOverImage.idx].storageLocation,
      dbg_id: reportImages[mouseOverImage.idx].dbg_id,
      path: reportImages[mouseOverImage.idx].dropboxPath,
    }]))
  }

  return (
    <Overlay show={show} target={mouseOverImage.target} placement="top">
      {(props) => (
        <Popover {...props} onMouseOver={keepOpen} onMouseLeave={() => closeOverlay()}>
          <Popover.Header>Photo Options</Popover.Header>
          <Popover.Body>
            <div>
              <Button
                variant="outline-secondary"
                name={mouseOverImage.idx || 0}
                value={-1}
                disabled={!mouseOverImage.idx}
                onClick={moveImage}>
                <ArrowLeft />
              </Button>
              <Button
                variant="outline-secondary"
                value={1}
                disabled={mouseOverImage.idx === reportImages.length - 1}
                name={mouseOverImage.idx || 0}
                onClick={moveImage}>
                <ArrowRight />
              </Button>
              <Button variant="outline-activated" value={mouseOverImage.idx} onClick={downloadPhoto}><File /></Button>
              <Button variant="outline-info" value={mouseOverImage.idx} onClick={uploadImageAndRefresh}><RefreshCcw /></Button>
            </div>
            <div>
              <Dropdown variant="outline-info" onSelect={onSelectThumbnailSize}>
                <Dropdown.Toggle>{show ? reportImages[mouseOverImage.idx].thumbnailSize : 'md'}</Dropdown.Toggle>
                <Dropdown.Menu>
                  {IMG_OPTIONS.map((size) => <Dropdown.Item key={size} eventKey={size}>{size}</Dropdown.Item>)}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div>
              <Button variant="outline-danger" onClick={(evt) => {
                if (deleteAttempted) {
                  setMouseOverImage({ idx: false })
                  setDeleteAttempted(false)
                  controlReducer({
                    type: 'changed', idx, name, update: {[name]: [
                      ...reportImages.slice(0, mouseOverImage.idx),
                      // { ...reportImages[mouseOverImage.idx], thumbnailSize: eventKey },
                      ...reportImages.slice(mouseOverImage.idx + 1)
                    ]}, childAction: {type: 'delete_block', idx: mouseOverImage.idx, name: 'overlay', file:reportImages[mouseOverImage.idx] }
                  })
                } else {
                  setDeleteAttempted(true)
                }
              }}>
                {!deleteAttempted ? (<Trash2 />) : 'Click again to delete photo'}
              </Button>
            </div>
          </Popover.Body>
        </Popover>
      )}
    </Overlay>
  )
}
function generateThumbnailRequest(image) {
  let { thumbnailSize, path, dbg_id, _id, storageLocation } = image
  if (!dbg_id) return { path, thumbnailSize }
  return {
    _id,
    dbg_id,
    thumbnailSize,
    storageLocation,
  }
}